module.exports = __webpack_public_path__ + "static/media/recharge.b2e53436.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/recharge.jpg
// module id = 561
// module chunks = 6